import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { QualificationReportQuestionsQuery } from "../../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../../utils";

const QUALIFICATION_REPORT_QUESTIONS_QUERY = graphql(`
  query qualificationReportQuestions {
    qualificationReportQuestions {
      questions {
        id
        title
        question
        order
        groupName
        teamId
        companyId
        autoQualify
      }
    }
  }
`);

export type QualificationQuestion =
  QualificationReportQuestionsQuery["qualificationReportQuestions"]["questions"][number];

export function useQualificationQuestions(
  options?: UseQueryOptions<
    QualificationReportQuestionsQuery,
    unknown,
    QualificationReportQuestionsQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["qualificationReportQuestions"],
    QUALIFICATION_REPORT_QUESTIONS_QUERY,
    [{}],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );
  return { ...rest, data: data?.qualificationReportQuestions };
}
